import React from 'react'
import './home.css';
import usePagesSEO from '../../hooks/usePagesSEO';

import Headers from '../../components/Header/Headers';
import Footers from '../../components/Footer'
import BottomFooter from '../../components/BottomFooter';
import Hero from './Hero/Hero.js';
import TraceShipping from './TraceShipping/traceShipping';
import Layanan from './Layanan'
import WhyHBU from './whyHBU/index.js';
import OptionBrand from './OptionBrand/index.js';



const Home = () => {
  usePagesSEO({
    pageTitle: "Home - HBU",
    pageDescription: "Welcome to HBU, your one-stop solution for all your needs.",
    pageKeywords: ["HBU", "Home", "Services", "Products"],
    ogTitle: "HBU - Home",
    ogDescription: "Discover the best services and products at HBU.",
    ogImage: "https://hbuexpress.com/static/media/hbu-color.5a8401d71148e9a49b46.png",
    ogUrl: "https://example.com/home"
  });

  return (
    <div className="home">
        <Headers></Headers> 
        <Hero></Hero>       
        <TraceShipping></TraceShipping>    
        <Layanan></Layanan> 
        <OptionBrand></OptionBrand>
        <WhyHBU></WhyHBU>
        
        <Footers></Footers>
        <BottomFooter></BottomFooter>
    </div>
  )
}

export default Home